import { object, string, minLength, maxLength, trim, pipe, InferOutput } from 'valibot';

export const MessageScheme = object({
  subject: pipe(string(), trim(), minLength(2), maxLength(100)),
  body: pipe(string(), trim(), minLength(2), maxLength(1000)),
});

export type MessageData = InferOutput<typeof MessageScheme>;

/**
 * Model for sending a message to the instructor.
 * Includes enrollment ID, message content, and flags for author messaging and redirect behavior.
 */
export interface MessageInstructorModel {
  enrollment_id: number;
  message: MessageData;
  message_to_author: boolean;
  disable_redirect: boolean;
}

/**
 * Response structure for a successful message to instructor operation.
 * Contains a success object with a title string.
 */
export interface MessageInstructorResponse {
  success: {
    title: string;
  };
}

export enum ResponseType {
  SUCCESS = 'success',
  ERROR = 'error',
}
